import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import React, { useState } from 'react';
import useEventListener from 'use-event-listener';

import Modal from '~/App/Components/Modal';

const ProtipModal = styled.div`
  padding: 25px 40px 40px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.48px;
  color: $brownish-grey;
  margin-bottom: 10px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.08px;
  color: $brown-grey;
  margin-bottom: 15px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.08px;
  color: $brown-grey-two;
  margin-bottom: 25px;
`;

const Button = styled.button`
  float: right;
`;

const ProtipRollup = ({ onConfirm }) => {
  const [isOpen, setOpen] = useState(false);

  useEventListener('protip-rollup-modal::open', () => {
    setOpen(true);
  });

  const handleGotIt = () => {
    setOpen(false);
    onConfirm();
  };

  const modalProps = {
    styles: {
      content: ({ base }) => ({
        ...base,
        top: '50%',
        transform: 'translateY(-60%)',
        padding: 'unset',
      }),
      panel: ({ base }) => ({
        ...base,
        maxWidth: 530,
        height: 602,
        position: 'relative',
        border: 'unset',
        overflow: 'hidden',
        margin: 'auto',
        padding: 'unset',
        borderRadius: 20,
      }),
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      hideActions={true}
      {...modalProps}
    >
      <video
        preload='auto'
        loop
        autoPlay
        muted
        width='530'
        height='370'
        style={{
          position: 'relative',
          background: '#06a7af',
          objectFit: 'cover',
        }}
      >
        <source
          src='https://dehjrbasx23dy.cloudfront.net/onboarding/RollupsAlert-NoAudio.mp4'
          type='video/mp4'
        />
      </video>
      <ProtipModal>
        <Subtitle>NEW FEATURE - ROLLUPS</Subtitle>
        <Title>Send one message to many people</Title>
        <Description>
          Save time by clicking on more than one recipient in the left column to
          send one video message to more than one contact.
        </Description>
        <Button onClick={handleGotIt} className='btn btn-primary'>
          Ok got it
        </Button>
      </ProtipModal>
    </Modal>
  );
};

ProtipRollup.propTypes = {
  addUserToOpenedList: PropTypes.func,
};

export default ProtipRollup;
